// src/components/family/OwnershipHint.jsx
import React from "react";
import { HandHeart, Crown, Gem } from "lucide-react";

/**
 * Mini-carte explicative du statut juridique d'une œuvre
 * (pleine propriété, usufruit, nue-propriété)
 * à afficher dans le profil client / fiche œuvre.
 *
 * @param {string} ownership_status - "full" | "usufruct" | "bare_ownership"
 * @param {string} [holderName] - nom de la personne concernée par ce statut (facultatif)
 */
export default function OwnershipHint({ ownership_status = "full", holderName = "" }) {
  const statusMap = {
    full: {
      icon: <Gem className="text-emerald-600" size={16} />,
      label: "Pleine propriété",
      text: "Le client détient l'ensemble des droits sur l'œuvre : usage, revenus et disposition.",
      bg: "bg-emerald-50 border-emerald-200 text-emerald-800",
    },
    usufruct: {
      icon: <Crown className="text-amber-600" size={16} />,
      label: "Usufruitier",
      text: "peut exposer, prêter ou louer l’œuvre, mais ne peut pas la vendre.",
      bg: "bg-amber-50 border-amber-200 text-amber-800",
    },
    bare_ownership: {
      icon: <HandHeart className="text-rose-600" size={16} />,
      label: "Nu-propriétaire",
      text: "détient la valeur patrimoniale mais pas la jouissance ni les revenus.",
      bg: "bg-rose-50 border-rose-200 text-rose-800",
    },
  };

  const info = statusMap[ownership_status] || statusMap.full;
  const body = holderName
    ? `${holderName} ${info.text}`
    : ownership_status === "full"
    ? info.text
    : `Le client ${info.text}`;

  return (
    <div
      className={`flex items-start gap-3 border rounded-md p-3 text-sm ${info.bg}`}
    >
      <div className="mt-0.5">{info.icon}</div>
      <div>
        <p className="font-medium">
          {info.label}
          {holderName ? ` — ${holderName}` : ""}
        </p>
        <p className="text-xs leading-snug">{body}</p>
      </div>
    </div>
  );
}
